<!-- **** --------------------------------------------------------------------------
	SHARED SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts">
    import vm from '@journeys/Journeys.viewmodel';
    import ScrollableContainer from '@shared/components/ScrollableContainer.vue';
</script>

<!-- **** --------------------------------------------------------------------------
	SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts" setup>
    const { canvas, editor, nav, settings } = vm;

    const props = defineProps<{}>();

    // const = (val: any) => {
    //    let v = val == false ? true : false

    //    return v
    // }
</script>

<!-- **** --------------------------------------------------------------------------
	TEMPLATE
-------------------------------------------------------------------------- **** -->
<template>
    <ScrollableContainer>
        <div class="section-group">
            <h3 class="title">canvas</h3>

            <div class="fl align-fl-items-e mt-xs mb-xs">
                <h4 class="mr-xs">
                    <span class="fw600">h:</span>
                    {{ canvas.h }}
                </h4>
                <h4>
                    <span class="fw600">w:</span>
                    {{ canvas.w }}
                </h4>
            </div>
            <div class="input-group fl mb-xs">
                <div class="input-wrapper fl-d-col align-fl-items-s">
                    <h4>exp.top</h4>
                    <input class="fluid-input" type="number" step="100" v-model="canvas.ext.t" />
                </div>

                <div class="input-wrapper fl-d-col align-fl-items-s">
                    <h4>exp.right</h4>
                    <input class="fluid-input" type="number" step="100" v-model="canvas.ext.r" />
                </div>

                <div class="input-wrapper fl-d-col align-fl-items-s">
                    <h4>exp.btm</h4>
                    <input class="fluid-input" type="number" step="100" v-model="canvas.ext.b" />
                </div>

                <div class="input-wrapper fl-d-col align-fl-items-s">
                    <h4>exp.left</h4>
                    <input class="fluid-input" type="number" step="100" v-model="canvas.ext.l" />
                </div>
            </div>

            <h4 class="title">display:</h4>
            <label class="root-checkbox simple-checkbox">
                Section helpers
                <input type="checkbox" label="testlabel" v-model="editor.dev.show.canvasGrid" />
                <div class="pseudo-checkbox"></div>
            </label>

            <div class="input-group fl mt-md mb-xs">
                <div class="input-wrapper fl-d-col align-fl-items-s">
                    <h4>nav.y</h4>
                    <input class="fluid-input" type="number" step="10" v-model="nav.y" />
                </div>

                <div class="input-wrapper fl-d-col align-fl-items-s">
                    <h4>nav.x</h4>
                    <input class="fluid-input" type="number" step="10" v-model="nav.x" />
                </div>
                <div class="input-wrapper fl-d-col align-fl-items-s">
                    <h4>nav.z</h4>
                    <input class="fluid-input" type="number" step="10" v-model="nav.z" />
                </div>
            </div>
        </div>

        <h3 class="title">observer: nodes</h3>
        <h4 class="title">shares 4 rotated containers</h4>
        <div class="fl align-fl-items-e mt-xs mb-xs">
            <h4 class="mr-xs">
                <span class="fw600">h:</span>
                {{ editor.state.nodeArea.h }}
            </h4>
            <h4>
                <span class="fw600">w:</span>
                {{ editor.state.nodeArea.w }}
            </h4>
        </div>
        <div class="input-group fl mb-xs">
            <div class="input-wrapper fl-d-col align-fl-items-s">
                <h4>top</h4>
                <input class="fluid-input" type="number" step="100" v-model="editor.state.nodeArea.t" />
            </div>

            <div class="input-wrapper fl-d-col align-fl-items-s">
                <h4>right</h4>
                <input class="fluid-input" type="number" step="100" v-model="editor.state.nodeArea.r" />
            </div>

            <div class="input-wrapper fl-d-col align-fl-items-s">
                <h4>btm</h4>
                <input class="fluid-input" type="number" step="100" v-model="editor.state.nodeArea.b" />
            </div>

            <div class="input-wrapper fl-d-col align-fl-items-s">
                <h4>left</h4>
                <input class="fluid-input" type="number" step="100" v-model="editor.state.nodeArea.l" />
            </div>
        </div>

        <h4 class="title">display:</h4>
        <label class="root-checkbox simple-checkbox">
            Observer
            <input type="checkbox" label="testlabel" v-model="editor.dev.show.nodeArea" />
            <div class="pseudo-checkbox"></div>
        </label>
        <label class="root-checkbox simple-checkbox">
            Pseudo elements
            <input type="checkbox" label="testlabel" v-model="editor.dev.show.pseudoHelpers" />
            <div class="pseudo-checkbox"></div>
        </label>
        <label class="root-checkbox simple-checkbox">
            line hitboxes
            <input type="checkbox" label="testlabel" v-model="editor.dev.show.hitboxes" />
            <div class="pseudo-checkbox"></div>
        </label>
        <label class="root-checkbox simple-checkbox">
            rendering & latency
            <input type="checkbox" label="testlabel" v-model="editor.dev.show.renderLatency" />
            <div class="pseudo-checkbox"></div>
        </label>

        <div class="section-group mt-sm">
            <h3 class="title">grid props</h3>

            <div class="input-group fl mb-xs">
                <div class="input-wrapper fl-d-col align-fl-items-s">
                    <h4>stroke width</h4>
                    <input class="fluid-input" type="number" step="1" v-model="settings.grid.strokeWidth" />
                </div>
                <div class="input-wrapper fl-d-col align-fl-items-s">
                    <h4>color</h4>
                    <input class="fluid-input" type="text" v-model="settings.grid.color" />
                </div>
                <div class="input-wrapper fl-d-col align-fl-items-s">
                    <h4>dot color</h4>
                    <input class="fluid-input" type="text" v-model="settings.grid.dotColor" />
                </div>
                <div class="input-wrapper fl-d-col align-fl-items-s">
                    <h4>center line color</h4>
                    <input class="fluid-input" type="text" v-model="settings.grid.centerLineColor" />
                </div>
            </div>
        </div>
    </ScrollableContainer>
</template>

<!-- **** --------------------------------------------------------------------------
	STYLES
-------------------------------------------------------------------------- **** -->
<style>
    .input-group .input-wrapper .fluid-input:not(.c) {
        margin-left: 0;
    }

    .root-checkbox {
        display: block;
        position: relative;
        padding-left: 30px;
        cursor: pointer;
        font-weight: 500;

        /* color:#fff; */
        padding-left: 1.85rem;
    }

    .root-checkbox input {
        z-index: -1;
        opacity: 0;
        pointer-events: none;
    }

    .root-checkbox input:checked ~ .pseudo-checkbox {
        background: #2aa1c0;
    }

    .pseudo-checkbox {
        position: absolute;
        top: 2px;
        left: 0;
        height: 20px;
        width: 20px;
        background: #e6e6e6;
        border-radius: 0.2rem;
    }

    .root-checkbox input:checked ~ .pseudo-checkbox:after {
        display: block;
    }

    .simple-checkbox .pseudo-checkbox:after {
        left: 7px;
        top: 4px;
        width: 6px;
        height: 10px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }

    .pseudo-checkbox:after {
        content: '';
        position: absolute;
        display: none;
    }
</style>
